export default __webpack_public_path__ + "static/media/rating.cc0ddd76.png";